import { inject, onUnmounted } from 'vue';
import type { EventBusInterface } from '@plugins/eventbus';

export default function useEventBus() {
    const eventbus = inject<EventBusInterface>('eventbus');

    if (!eventbus) {
        throw new Error('Trying to use plugin pubsub, but plugin not enabled');
    }

    const subscribersFromComponent: {
        subscription: string,
        subscriberId: string,
    }[] = [];

    const subscribeFromComponent = <Params>(subscription: string, subscriber: (params: Params) => void) => {
        const subscriberId = eventbus.subscribe(subscription, subscriber);

        subscribersFromComponent.push({
            subscription,
            subscriberId,
        });

        return subscriberId;
    };

    onUnmounted(() => {
        subscribersFromComponent.forEach((subscriberFromComponent) => {
            eventbus.unsubscribe(subscriberFromComponent.subscription, subscriberFromComponent.subscriberId);
        });
    });

    return {
        dispatch: eventbus.dispatch,
        subscribe: subscribeFromComponent,
        getSubscriptions: eventbus.getSubscriptions,
        getCurrentComponentSubscriptions: () => subscribersFromComponent,
    };
}
